export const BUYER_MODELS_PER_PAGE = 5;
